import React from 'react';
import Link from 'next/link';
import { Div, ListItem, Text } from '@pezeshk-book/ui-kit';
import { HtmlRendererProps } from './html-renderer.props';
import Image from '@elements/image';
import Renderer from './react-html-renderer';
import AccordionSummary from '@pezeshk-book/ui-kit/accordion/accordion-summary';
import AccordionDetails from '@pezeshk-book/ui-kit/accordion/accordion-details';
import Accordion from '@pezeshk-book/ui-kit/accordion/accordion';

const HtmlRenderer = ({ html, chaptersTitle }: HtmlRendererProps) => {
  return (
    <Renderer
      html={html}
      components={{
        h1: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5  before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h1'} typography={'xxl'}>{children}</Text>,
        h2: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5 before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h2'} typography={'xl'}>{children}</Text>,
        h3: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5 before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h3'} typography={'xl'}>{children}</Text>,
        h4: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5 before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h4'} typography={'xl'}>{children}</Text>,
        h5: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5 before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h5'} typography={'xl'}>{children}</Text>,
        h6: ({ children, id }: any) => <Text id={id} className={'mt-5 flex items-center before:mr-2 before:w-2 before:h-5 before:bg-tertiary-500'} direction={'auto'} align={'start'} type={'bold'} variant={'h6'} typography={'xl'}>{children}</Text>,
        b: ({ children }: any) => (
          <Text className={'pr-2'} direction={'auto'} align={'start'} variant={'span'} type={'bold'}>{children}</Text>
        ),
        strong: ({ children }: any) => (
          <Text className={'pr-2'} direction={'auto'} align={'start'} variant={'span'} type={'bold'}>{children}</Text>
        ),
        a: ({ children, href, ...rest }: any) => {
          if (href) {
            return (
              <Link passHref={true} href={href || ''} {...rest} className={'!inline !p-0.5'}>
                {children}
              </Link>
            );
          }
          return (
            <Text variant={'span'} className={'mt-[10px] mb-[10px] w-full'} direction={'auto'} align={'start'}>{children}</Text>
          );
        },
        style: ({ children }: any) => null,
        font: ({ children }: any) => children,
        span: ({ children }: any) => children,
        img: ({ children, src, alt }: any) => (
          <Div className={'relative self-center w-[80%] max-w: [70%] flex-col'}>
            {/^https?:\/\/(pezeshkbook.appcosolution.com|maps.googleapis.com|pezeshkbook.com)?/.test(src) ? (
              <Image sizes={'50vw'} fill={false} width={100} height={100} className={'w-full rounded-[30px] mx-[30px] object-contain'} src={src} alt={alt || 'تصویر بلاگ'} />
            ) : (
              <img className={'w-full rounded-[30px] mx-[30px]'} src={src} alt={alt || 'تصویر بلاگ'} />
            )}
          </Div>
        ),
        div: ({ children, class: className }: any) => {
          if (className === 'widget-toc') {
            return (
              <Accordion className={'shadow-lg w-full'} variant={'outlined'} rounded={'medium'} color={'control'}>
                <AccordionSummary
                  size={'large'}
                  className={'justify-between relative'}>
                  <Text align={'start'} type={'bold'} color={'inherit'}>{chaptersTitle}</Text>
                </AccordionSummary>
                <AccordionDetails>
                  {children}
                </AccordionDetails>
              </Accordion>
            );
          }
          return (
            <Div className={'flex-col'}>
              {children}
            </Div>
          );
        },
        p: ({ children }: any) => (
          <Text className={'mt-[10px] mb-[10px] w-full'} direction={'auto'} align={'start'}>{children}</Text>
        ),
        li: ({ children }: any) => (
          <ListItem className={'py-0'} hasBullet={true} direction={'auto'}>
            <Div className={'flex-col'}>
              {children}
            </Div>
          </ListItem>
        ),
      }}
    />
  );
};

export default HtmlRenderer;
